import * as types from './../constants/lessonSparkViewRecordActionTypes';

const initialState = {
  lessonSparkViewRecords: {
    dateRequested: null,
    dateLoaded: null,
    isLoading: false,
    items: [],
  }
};

function lessonSparkViewRecords(state = initialState.lessonSparkViewRecords, action) {
  switch (action.type) {
    case types.LESSON_SPARK_USER_VIEW_LOAD_REQUEST:
      return {...state, dateRequested: Date.now(), isLoading: true};

    case types.LESSON_SPARK_USER_VIEW_LOAD_SUCCESS:
      return {
        ...state,
        dateLoaded: Date.now(),
        isLoading: false,
        items: [...action.lessonSparkViewRecords]
      };

    case types.LESSON_SPARK_USER_VIEW_LOAD_FAILURE:
      return {...state, isLoading: false, error: action.error};

    default:
      return state;
  }
}

export default lessonSparkViewRecords;
